export default class ShortcutButton {
  init() {
    //
  }
}
